/* tslint:disable */
/* eslint-disable */
/**
 * OSB Workspaces manager API
 * Opensource Brain Platform - Reference Workspaces manager API
 *
 * The version of the OpenAPI document: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    RepositoryResourceBase,
    RepositoryResourceBaseFromJSON,
    RepositoryResourceBaseFromJSONTyped,
    RepositoryResourceBaseToJSON,
} from './';

/**
 * dandi repository resource
 * @export
 * @interface DandiRepositoryResource
 */
export interface DandiRepositoryResource {
    /**
     * file name
     * @type {string}
     * @memberof DandiRepositoryResource
     */
    name?: string;
    /**
     * Download URL of the Resource
     * @type {string}
     * @memberof DandiRepositoryResource
     */
    path?: string;
    /**
     * OSB Repository id
     * @type {number}
     * @memberof DandiRepositoryResource
     */
    osbrepositoryId?: number;
    /**
     * File size in bytes of the RepositoryResource
     * @type {number}
     * @memberof DandiRepositoryResource
     */
    size?: number;
    /**
     * Date/time the ReposityResource is last modified
     * @type {Date}
     * @memberof DandiRepositoryResource
     */
    timestampModified?: Date;
}

export function DandiRepositoryResourceFromJSON(json: any): DandiRepositoryResource {
    return DandiRepositoryResourceFromJSONTyped(json, false);
}

export function DandiRepositoryResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): DandiRepositoryResource {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'path': !exists(json, 'path') ? undefined : json['path'],
        'osbrepositoryId': !exists(json, 'osbrepository_id') ? undefined : json['osbrepository_id'],
        'size': !exists(json, 'size') ? undefined : json['size'],
        'timestampModified': !exists(json, 'timestamp_modified') ? undefined : (new Date(json['timestamp_modified'])),
    };
}

export function DandiRepositoryResourceToJSON(value?: DandiRepositoryResource | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'path': value.path,
        'osbrepository_id': value.osbrepositoryId,
        'size': value.size,
        'timestamp_modified': value.timestampModified === undefined ? undefined : (value.timestampModified.toISOString()),
    };
}


